var SENTRY_RELEASE;SENTRY_RELEASE={name: "Evidensia", version: "1.0.1"};